<script>
import formatDate, { formatRequestData, lunarToSolar, lunarDateTime } from '@utils/format-date'

const minutesOfTime = (time = '00:00') => {
  const timeMatches = time.match(/^(\d+):(\d+)$/i)
  const [, hours, minutes] = timeMatches
  return Number(hours) * 60 + Number(minutes)
}

const initData = {
  state: 1,
  title: '',
  saleStartDate: '',
  saleStartTime: '',
  saleEndDate: '',
  saleEndTime: '',
}

export default {
  components: {},
  data() {
    return {
      dialog: false,
      activeYear: '',
      list: [],
      submitData: Object.assign({}, initData),
      tryingStoreYear: false,
      dropdownList: [],
      searchQuery: '',
    }
  },
  computed: {
    productId() {
      return this.$route.params.productId
    },
    isEditMode() {
      return this.submitData.id !== undefined
    },
    years() {
      const yearList = []
      let year = new Date().getFullYear()
      for (let i = year; i < year + 10; i++) {
        let startDate = lunarToSolar(`${i}-1-1`)
        let endDate = lunarToSolar(`${i}-12-30`) === -1 ? lunarToSolar(`${i}-12-29`) : lunarToSolar(`${i}-12-30`)
        yearList.push({
          title: `${i}${startDate.gzYear}肖${startDate.Animal}(民國${i - 1911}年)`,
          startDate: formatDate(new Date(startDate.date), 'date-dash'),
          startTime: '00:00',
          endDate: formatDate(new Date(endDate.date), 'date-dash'),
          endTime: '23:59',
          repeat: '',
          infinity: 1,
          inventory: 1, // 不傳 inventory 會出錯
        })
      }
      return yearList
    },
    submitRules() {
      return {
        saleStartDate: [
          {
            required: true,
            message: '請選擇開賣日期',
            trigger: 'change',
          },
        ],
        saleStartTime: [
          {
            validator: (rule, value, callback) => {
              if (!value) return callback(new Error('請選擇時段開賣時間'))
              if (this.submitData.saleEndTime) this.$refs.form.validateField('saleEndTime')

              callback()
            },
            trigger: 'change',
          },
        ],
        saleEndDate: [
          {
            validator: (rule, value, callback) => {
              if (!value) return callback(new Error('請選擇結束販售日期'))
              if (this.submitData.saleEndTime) this.$refs.form.validateField('saleEndTime')

              callback()
            },
            trigger: 'change',
          },
        ],
        saleEndTime: [
          {
            validator: (rule, value, callback) => {
              if (!value) return callback(new Error('請選擇結束販售時間'))

              const { saleStartDate, saleEndDate, saleStartTime } = this.submitData
              const isSameDate = saleStartDate instanceof Date ? saleStartDate.getDate() === saleEndDate.getDate() : saleStartDate === saleEndDate

              if (isSameDate && minutesOfTime(saleStartTime) >= minutesOfTime(value)) return callback(new Error('結束時間不可早於開始時間'))
              callback()
            },
            trigger: 'change',
          },
        ],
      }
    },
    endDatePickerOptions() {
      return {
        disabledDate: (time) => {
          // check String or Date Object
          const selectedStartDate = this.submitData.startDate instanceof Object ? this.submitData.saleStartDate : new Date(this.submitData.saleStartDate)
          const limitWith365Days = selectedStartDate.getTime() + 3600 * 1000 * 24 * 365
          return time < selectedStartDate || time.getTime() >= limitWith365Days
        },
      }
    },
    searchResult() {
      this.activeYear = ''
      this.$emit('hide')
      return this.list.filter((item) => item.title.includes(this.searchQuery))
    },
  },
  created() {
    this.tryToFetchYear(true)
  },
  methods: {
    lunarDateTime,
    async tryToFetchYear(emit = false) {
      const { items } = await this.$store.dispatch('inventory/fetchGroups', { productId: this.productId, query: { order_by: 'startDate', order: 'asc' } })
      this.list = items
      if (this.list.length) {
        // this.$emit('show-light')
        this.dropdownList = this.years.filter((o1) => !this.list.some((o2) => o1.startDate === o2.startDate))
        if (emit) {
          this.$emit('update-year', this.list[0])
          this.$emit('show-light')
          this.activeYear = 0
        } else if (!this.isEditMode) {
          this.$emit('update-year', this.list[this.list.length - 1])
          this.$emit('show-light')
          this.activeYear = this.list.length - 1
          this.searchQuery = ''
        }
      } else this.dropdownList = this.years
    },
    async tryToStoreYear() {
      this.tryingStoreYear = true
      const formatData = this.formatSubmitData()
      await this.$store.dispatch('inventory/storeGroups', {
        productId: this.productId,
        submitData: [formatData],
      })
      this.tryToFetchYear(false)
      this.dialog = false
      this.tryingStoreYear = false
    },
    editCurrentYear(item) {
      this.submitData = {
        ...item,
        state: item.inventoriesState,
        saleStartDate: new Date(item.saleStartDate),
        saleStartTime: item.saleStartDate.split(' ')[1],
        saleEndDate: new Date(item.saleEndDate),
        saleEndTime: item.saleEndDate.split(' ')[1],
      }
      this.openDialog()
    },
    updateActiveYear(item, index) {
      this.$emit('update-year', item)
      this.$emit('show-light')
      this.activeYear = index
    },
    openDialog() {
      this.dialog = true
    },
    onClickStore() {
      this.$refs.form.validate((valid) => {
        if (valid) this.tryToStoreYear()
      })
    },
    onDialogClose() {
      this.submitData = Object.assign({}, initData)
      this.$refs.form.resetFields()
    },
    formatSubmitData() {
      const { saleStartDate, saleStartTime, saleEndDate, saleEndTime, repeatEndDate, ...restSubmitData } = this.submitData
      if (this.isEditMode) {
        return {
          ...restSubmitData,
          saleStartDate: formatRequestData(saleStartDate) + ' ' + saleStartTime,
          saleEndDate: formatRequestData(saleEndDate) + ' ' + saleEndTime,
        }
      } else {
        let [lunarInfo] = this.years.filter((year) => year.title === this.submitData.title)
        return {
          ...restSubmitData,
          ...lunarInfo,
          saleStartDate: formatRequestData(saleStartDate) + ' ' + saleStartTime,
          saleEndDate: formatRequestData(saleEndDate) + ' ' + saleEndTime,
        }
      }
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.header">
      <el-input v-model.trim="searchQuery" placeholder="搜尋年份" clearable style="margin-bottom: 10px;">
        <BaseIcon slot="prefix" name="search" class="el-input__icon" />
      </el-input>
      <el-button style="width:100%;" type="primary" plain @click="dialog = true"><BaseIcon name="plus" /> 新增年份</el-button>
    </div>
    <div :class="$style.list"
      ><div
        v-for="(item, index) in searchQuery ? searchResult : list"
        :key="`year-${index}`"
        :class="[$style.item, index === activeYear ? $style.active : '']"
        @click.self="updateActiveYear(item, index)"
      >
        <span style="pointer-events: none;">{{ item.title }}</span>
        <el-tooltip content="編輯年份" placement="top"
          ><el-button v-show="index === activeYear" plain @click="editCurrentYear(item)"><BaseIcon name="edit"/></el-button
        ></el-tooltip>
      </div>
    </div>

    <el-dialog :title="isEditMode ? '編輯年份' : '新增年份'" :visible.sync="dialog" width="740px" top="0" append-to-body @close="onDialogClose">
      <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form--floating" style="margin-top: 20px;">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="選擇年份" prop="year">
              <el-select v-if="!isEditMode" v-model="submitData.title" value-key="title" placeholder="請選擇">
                <el-option v-for="year in dropdownList" :key="year.cYear" :label="year.title" :value="year.title"> </el-option>
              </el-select>
              <el-input v-else v-model="submitData.title" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <template></template>
            <el-form-item label="年份顯示" prop="state">
              <el-switch v-model="submitData.state" active-text="開" inactive-text="關" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item :class="$style['form-item--split']" label="開賣日期與時間" required>
              <el-form-item class="el-form-item--normal-margin" prop="saleStartDate">
                <el-date-picker v-model="submitData.saleStartDate" format="yyyy/MM/dd" type="date" :clearable="false"></el-date-picker>
              </el-form-item>
              <el-form-item class="el-form-item--normal-margin" prop="saleStartTime">
                <el-time-picker v-model="submitData.saleStartTime" format="HH:mm" value-format="HH:mm" placeholder="選擇開始時間" :clearable="false"></el-time-picker>
              </el-form-item>
            </el-form-item>
          </el-col>
          <el-col :span="2" :class="$style['form-item--separator']">～</el-col>
          <el-col :span="11">
            <el-form-item :class="$style['form-item--split']" label="結束販售日期與時間" required>
              <el-form-item class="el-form-item--normal-margin" prop="saleEndDate">
                <el-date-picker v-model="submitData.saleEndDate" format="yyyy/MM/dd" type="date" :clearable="false" :picker-options="endDatePickerOptions"></el-date-picker>
              </el-form-item>
              <el-form-item class="el-form-item--normal-margin" prop="saleEndTime">
                <el-time-picker v-model="submitData.saleEndTime" format="HH:mm" value-format="HH:mm" placeholder="選擇結束時間" :clearable="false">aaa</el-time-picker>
              </el-form-item>
            </el-form-item>
          </el-col>

          <el-col :span="11"><el-form-item :class="$style['lunar-date-time']" :label="`農曆：${lunarDateTime(submitData.saleStartDate, submitData.saleStartTime)}`"></el-form-item></el-col>
          <el-col :span="2" style="visibility: hidden;" :class="$style['form-item--separator']">～</el-col>
          <el-col :span="11"><el-form-item :class="$style['lunar-date-time']" :label="`農曆：${lunarDateTime(submitData.saleEndDate, submitData.saleEndTime)}`"></el-form-item></el-col>
        </el-row>
      </el-form>
      <div :class="$style.footer">
        <el-button plain @click="dialog = false">取消</el-button>
        <el-button :loading="tryingStoreYear" :disabled="tryingStoreYear" type="primary" @click="onClickStore">
          <BaseIcon name="check" />
          <span>{{ isEditMode ? '儲存' : '建立' }}</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" module>
.header {
  padding: 15px;
  border: 1px solid rgba(211, 211, 211, 0.4);
  border-top: none;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px 0px 20px;
  cursor: pointer;
  height: 50px;
  border-bottom: 1px solid rgba(211, 211, 211, 0.4);
  border-top: none;
  &.active {
    background-color: #f2ac57;
    color: white;
    border: none;
    :global {
      button {
        background-color: #f2ac57 !important;
        color: white !important;
        padding: 17px;
        padding-right: 8px;
        border: none;
        font-size: 16px;
      }
    }
  }
}
.list {
  overflow: auto;
  height: 345px;
  border: 1px solid rgba(211, 211, 211, 0.4);
  border-top: none;
}

.form-item {
  &--split {
    :global {
      .el-form-item__content {
        display: flex;
        align-items: center;
      }
      .el-form-item + .el-form-item {
        margin-left: 10px;
      }
    }
  }
  &--separator {
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
}
.lunar-date-time {
  :global {
    .el-form-item__label {
      color: #6e4302;
      font-weight: 500;
    }
  }
}
.footer {
  padding-bottom: 15px;
  text-align: center;
  :global {
    button {
      width: 160px;
    }
  }
}
</style>
